import { h } from 'vue';

import { Text } from '@/utils';

export default {
    props:
    {
        isOpen:
        {
            type: Boolean,
            default: false,
        },

        items:
        {
            type: Array,
            default: null,
        },

        onSelect:
        {
            type: Function,
        },

        toggleDropdown:
        {
            type: Function
        }
    },

    render()
    {
        return h(
            'div',

            {
                class: Text.joinClass(
                    'vh-autocomplete',
                    this.isOpen ? 'vh-open' : ''
                ),
            },

            [
                this.items.length !== 0
                    ? h(
                        'ul',

                        {
                            class: 'vh-list vh-autocomplete-list',
                        },

                        [
                            this.items.map(item => h(
                                'li',

                                {
                                    onClick: () => 
                                    {
                                        this.onSelect(item);

                                        this.toggleDropdown(false);
                                    },
                                },

                                [
                                    h(
                                        'p',

                                        {
                                            class: 'vh-text-bold vh-margin-remove',
                                        },

                                        item.title
                                    ),

                                    h(
                                        'p',

                                        {
                                            class: 'vh-margin-remove',
                                        },

                                        item.label
                                    ),
                                ]
                            )),
                        ]
                    )

                    : h(
                        'div',

                        {
                            class: 'vh-padding',
                        },

                        [
                            h(
                                'p',

                                {
                                    class: 'vh-text-lead vh-margin-remove',
                                },

                                'No Results 😢'
                            ),

                            h(
                                'p',

                                {
                                    class: 'vh-text-meta vh-margin-remove',
                                },

                                'Your search returned no results'
                            ),
                        ]
                    ),
            ]
        );
    },
};
